function getCookie(name) {
  return document.cookie
    .split('; ')
    .find(row => row.startsWith(name + '='))
    ?.split('=')[1] || null
}

function triggerEvent(mainEventName, purchaseValue = null) {
  const btag = decodeURIComponent(getCookie('ad_source_btag') || '')
  console.log(`[Event] ${mainEventName} → btag=${btag}`)
}

export function sendRegisterEvent() {
  triggerEvent('CompleteRegistration')
}

export function sendFirstPurchaseEvent() {
  triggerEvent('Purchase')
}
